import { render, staticRenderFns } from "./ProductCategoryCard.vue?vue&type=template&id=2aa71f38&scoped=true&"
import script from "./ProductCategoryCard.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductCategoryCard.vue?vue&type=style&index=0&id=2aa71f38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa71f38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
